import Popup from 'reactjs-popup'
import awardIcon from '../../../../assets/images/award.png'

const MobileAwardModal = ({
  percent,
  mobileModalAwardOpened,
  handleCloseAwardModal,
}) => {
  return (
    <Popup
      open={mobileModalAwardOpened}
      closeOnDocumentClick
      onClose={handleCloseAwardModal}
      className="popup"
    >
      <div className="modal">
        <img
          className="fade"
          alt="hintImage"
          src={awardIcon}
          width={300}
          height={300}
        />
        <div className="flex items-center justify-center">
          <div className="flex flex-col">
            <div className="flex justify-center items-center flex-col">
              <div className="flex flex-col gap-[10px]  !font-normal text-left">
                <div className="flex justify-center items-center text-xl font-bold">
                  Felicitări !
                </div>
                <div className="rounded flex justify-center items-center text-center p-[4px] text-black">
                  <div className="font-bold text-lg">
                    Te-ai descurcat mai bine decât {''}
                    <span className="text-[#00D9B2FF]">{percent}</span> din
                    utilizatori
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="button mt-[20px] button-primary"
          onClick={handleCloseAwardModal}
        >
          Închide
        </button>
        <a className="close" onClick={handleCloseAwardModal}>
          &times;
        </a>
      </div>
    </Popup>
  )
}

export default MobileAwardModal
